function download(url, fileName) {
    const downloadLink = document.createElement("a");
    downloadLink.href = url;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
}

export function saveSVG(svgText, fileName) {
    const svgBlob = new Blob([svgText], { type: "image/svg+xml;charset=utf-8" });
    const svgUrl = URL.createObjectURL(svgBlob);
    download(svgUrl, fileName);
}

export function saveSvgAsPng(svgText, fileName, w, h) {
    var canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext("2d");
    var image = new Image();
    image.onload = function () {
        ctx.drawImage(image, 0, 0);
        download(canvas.toDataURL("image/png"), fileName);
    };
    image.src = "data:image/svg+xml;charset=utf-8;base64," + Buffer.from(svgText).toString("base64");
    // image.src = "data:image/svg+xml;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(svgText)));
}
